import { useEffect } from 'react';
import CardDiscipline from '../../../../modules/Memory/components/card-discipline';
import useFlashcardByVideoAula from '../../../../modules/Memory/hooks/use-flashcard-by-video-aula';
import BrainLoadingWrapper from '../../molecules/BrainLoading';
import { Typography } from '../../molecules/Typography';

const FlashcardsLesson = ({
  videoAulaId,
  selected,
}: {
  videoAulaId: string;
  selected: boolean;
}) => {
  const {
    flashcards,
    isLoading: isLoadingFlashcards,
    fetchFlashcards,
  } = useFlashcardByVideoAula();

  useEffect(() => {
    if (!videoAulaId) return;

    fetchFlashcards(videoAulaId);
  }, [videoAulaId, fetchFlashcards]);

  const shouldShowFlashcards = !isLoadingFlashcards && flashcards.length > 0;

  if (!selected) return null;

  return (
    <>
      {isLoadingFlashcards && <BrainLoadingWrapper />}
      {shouldShowFlashcards && (
        <div className='mb-8 mt-8 flex flex-col gap-sm'>
          <Typography
            type='titleSection'
            size='h5'
            className='text-mono-color-black'
          >
            <i>Flashcards</i> da videoaula
          </Typography>
          <div className='grid grid-cols-1 gap-3 md:grid-cols-2'>
            {flashcards.map((flashcard) => (
              <CardDiscipline
                key={flashcard.uuid}
                className='w-full bg-disciplina-matematica'
                classNameIcon='text-disciplina-matematica'
                front={flashcard.front}
                uuid={flashcard.uuid}
                tags={flashcard?.tags || []}
                discipline={flashcard?.discipline || undefined}
                hasVinculed={flashcard?.hasVinculed || false}
                shouldReview={flashcard?.shouldReview || false}
                onSuccessFallback={() => fetchFlashcards(videoAulaId)}
              />
            ))}
          </div>
        </div>
      )}
    </>
  );
};

export default FlashcardsLesson;
